import React, { Component } from 'react'
import { Button, TextField, Grid, Typography } from '@material-ui/core';
import { withRouter } from "react-router";
import { LoginProps } from '../connected/LoginCnn'
import EmailInput from './EmailTBox';

type LoginBoxState = {
    password: string,
    email: string,
    emailFormatError: boolean,
}

class LoginBox extends Component<LoginProps, LoginBoxState> {

    constructor(props: any) {
        super(props)
        this.state = {
            password: '',
            email: '',
            emailFormatError: false
        }

        this.login = this.login.bind(this)
    }


    login() {
        this.props.login(this.state.email, this.state.password)
    }

    render() {
        return (
            <Grid container style={{ textAlign: 'center' }}>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant="h4" color="error">{this.props.loginErrorMessage}</Typography>
                </Grid>
                <Grid item sm={3} md={4}></Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <div>
                        <EmailInput email={this.state.email} onChange={(val: string) => this.setState({ email: val })} onFormatErrorChange={(isError: boolean) => this.setState({ emailFormatError: isError })} />
                    </div>
                    <div>
                        <TextField
                            label="Password"
                            type="password"
                            autoComplete="current-password"
                            margin="normal"
                            variant="outlined"
                            value={this.state.password}
                            onChange={(e) => this.setState({ password: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13)
                                    this.login()
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}></Grid>
                <Grid item xs={12} sm={12} style={{ paddingBottom: '5px' }}>
                    <Typography variant="h5" color="primary"><span style={{cursor:"pointer"}} onClick={() => this.props.history.push("/ResetPassword")}>Forgot password?</span></Typography>
                </Grid>

                <Grid item sm={3} md={4}></Grid>
                <Grid item xs={12} sm={6} md={4} style={{ paddingTop: '15px' }}>
                    <Button 
                    style={{ width: '100%' }} 
                    variant="contained" 
                    color="primary" 
                    disabled={this.state.emailFormatError || this.state.password === ""}
                    onClick={(e) => this.login()}>Log in</Button>
                </Grid>
                <Grid item sm={3} md={4}></Grid>
            </Grid>
        )
    }
}

export default withRouter(LoginBox)
